var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDialog,
          expression: "showDialog",
        },
      ],
      staticClass: "ui-dialog",
      class: { "ui-dialog__backdrop": _vm.backdrop },
      on: {
        click: function ($event) {
          return _vm.onBackdropClick($event)
        },
      },
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showDialog
          ? _c(
              "div",
              {
                staticClass: "ui-dialog__wrapper",
                class: { "ui-dialog__large": _vm.large },
              },
              [
                _c(
                  "div",
                  { staticClass: "ui-dialog__content" },
                  [
                    _vm.closable
                      ? _c("ui-button", {
                          staticClass: "ui-dialog__close-button",
                          attrs: { dense: "", icon: "fal fa-times" },
                          on: { click: _vm.close },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ui-dialog__title",
                        style: _vm.closable ? { "margin-right": "32px" } : {},
                      },
                      [
                        _vm.title
                          ? _c("h6", { staticClass: "ui-title" }, [
                              _vm._v(_vm._s(_vm.title)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("header"),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._t("default"),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }